import { Box, IconButton, Stack } from '@mui/material'
import React, { useCallback, useMemo, useState } from 'react'
import { K1View, K1Blindness, J2Copy } from '@e3dc-react/icons'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  value: string
  clipboardMessage?: string
  displayCopy?: boolean
}

const SecureDataField: React.VFC<Props> = ({ value, clipboardMessage, displayCopy = false }) => {
  const [doDisplayCode, setDoDisplayCode] = useState(false)
  const { enqueueSuccessStack } = useSnackbar()
  const { t } = useCustomTranslation()
  const displayedValue = useMemo<string>(() => {
    if (doDisplayCode) return value
    return value
      .split('')
      .map(() => '*')
      .join('')
  }, [doDisplayCode, value])
  const toggleVisibility = useCallback(() => {
    setDoDisplayCode(!doDisplayCode)
  }, [doDisplayCode])

  const handleCopyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(value).catch(console.error)
    enqueueSuccessStack(clipboardMessage || t('common.copied-to-clipboard'))
  }, [value, enqueueSuccessStack, clipboardMessage, t])

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Box sx={{ mr: 1, flexGrow: 1, wordBreak: 'break-word' }}>{displayedValue}</Box>
      {displayCopy && (
        <IconButton onClick={handleCopyToClipboard}>
          <J2Copy />
        </IconButton>
      )}
      <IconButton onClick={toggleVisibility}>
        {doDisplayCode && <K1View />}
        {!doDisplayCode && <K1Blindness />}
      </IconButton>
    </Stack>
  )
}

export default SecureDataField
